import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel, getUserProps } from '..';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

export type CtaDriverProductType =
  | 'Home Price Guide'
  | 'Appraisal Funnel'
  | 'Recently Sold';

export interface CtaDriverTrackingProps {
  productType: CtaDriverProductType;
  interactionCTA: string;
  elementListPosition: number;
  elementTargetCategoryPrimary: string;
  elementTargetPageType: string;
  elementTitle: string;
  modules?: FaaLandingPageModule[];
}

const trackCtaDriver = ({
  productType,
  interactionCTA,
  elementListPosition,
  elementTargetCategoryPrimary,
  elementTargetPageType,
  elementTitle,
  modules = getVisibleLandingPageModules(),
}: CtaDriverTrackingProps): void => {
  sendToMixpanel('Tap CTA Driver', {
    productType,
    interactionCTA,
    modules,
    modulesCount: modules.length,
    ...getUserProps(),
  });

  pushToDataLayer({
    event: 'cta_driver',
    event_parameters: {
      element_list_name: 'Find an Agent CTA drivers',
      element_list_position: elementListPosition,
      element_target_category_primary: elementTargetCategoryPrimary,
      element_target_page_type: elementTargetPageType,
      element_text: interactionCTA,
      element_title: elementTitle,
      element_type: 'Widget',
    },
  });
};

export default trackCtaDriver;
